// components
import Purchases from "../Components/Purchases/Purchases";
const PurchasesPage = () => {
    return (
        <Purchases />
    )
}
export default PurchasesPage;